import React, { useState, useEffect, useCallback } from 'react';
import { Loader } from '@perxis/perxis-auto-ui-kit/lib/components/Loader';

import config from '@/utils/config';
import { TEventDetail } from '@/types/common';
import { ICarItem } from '@/types/car';
import { INSTOCK_CAR_DATA_RECEIVED_EVENT, INSTOCK_CHANNEL } from '@/constants/events';
import { TCarPayload } from '@/apps/pre-order-form/types';
import useBookingData from '@/apps/pre-order-form/hooks/useBookingData';
import ConfirmationStep from './ConfirmationStep';
import PreOrderForm from './PreOrderForm';

import style from './style.module.scss';

type AppProps = any;

const App = (props: AppProps) => {
  const initCarData = config.get('car') ?? null;

  const [carData, setCarData] = useState<ICarItem | null>(initCarData);

  const { bookingToken, bookingInfo, bookingAgreementData, bookingInfoError } =
    useBookingData();

  const isHiddenForm = !carData && !bookingToken;

  const handleCarReceived = useCallback((e: CustomEvent<TEventDetail<TCarPayload>>) => {
    const { detail } = e;
    if (detail?.type === INSTOCK_CAR_DATA_RECEIVED_EVENT) {
      setCarData(detail.car);
    }
  }, []);

  useEffect(() => {
    const listener = handleCarReceived as EventListener;
    document.addEventListener(INSTOCK_CHANNEL, listener);
    return () => {
      document.removeEventListener(INSTOCK_CHANNEL, listener);
    };
  }, [handleCarReceived]);

  if (isHiddenForm) {
    return null;
  }

  return (
    <div
      className={cn(style.widget, config.get('widgetClassName'))}
      style={config.get('widgetStyle')}
    >
      <div className={style.container}>
        {carData ? (
          <PreOrderForm car={carData} />
        ) : (
          <Loader spinning={!bookingInfoError && (!bookingInfo || !bookingAgreementData)}>
            <ConfirmationStep
              bookingInfo={bookingInfo}
              bookingAgreementData={bookingAgreementData}
              bookingInfoError={bookingInfoError}
            />
          </Loader>
        )}
      </div>
    </div>
  );
};

export default App;
